import { useORPCQuery } from "Core/oRPC";
import { Images } from "Shared/Utils";

import { useQueries, UseQueryResult } from "@tanstack/react-query";
import { useCallback } from "react";

export const usePersonImages = (aliasList: string[], inView: boolean = true): { aliasPhotoMap: Map<string, string>; results: UseQueryResult<string>[] } => {
    const { coreApi } = useORPCQuery();

    const combineFunc = useCallback(
        (results: UseQueryResult<string, Error>[]) => {
            const aliasPhotoMap = new Map<string, string>();
            results.forEach((result, index) => {
                const alias = aliasList[index];
                if (alias) {
                    aliasPhotoMap.set(alias, Images.getBase64ImgSrc(result.data));
                }
            });
            return {
                aliasPhotoMap,
                results
            };
        },
        [aliasList]
    );

    const combinedResults = useQueries({
        queries: aliasList.map((alias) =>
            coreApi.getProfilePhoto.queryOptions({
                input: { alias: alias },
                staleTime: Infinity,
                enabled: alias.length > 0 && inView
            })
        ),
        combine: combineFunc
    });

    return combinedResults;
};
